// extracted by mini-css-extract-plugin
export default {"section-heading":"TourismAround_section-heading__cSExf","tourism-around-card":"TourismAround_tourism-around-card__3uo9l","collapse-icon":"TourismAround_collapse-icon__rgRo4"};